import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';

function AppShell() {
  const { user, login } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/home" replace /> : <Login onLogin={login} />} />
      <Route path="/" element={<Navigate to={user ? '/home' : '/login'} replace />} />
      <Route path="/home" element={user ? <Dashboard /> : <Navigate to="/login" replace />} />
      <Route path="/s/:sectionId" element={user ? <Dashboard /> : <Navigate to="/login" replace />} />
      <Route path="/s/:sectionId/:toolId" element={user ? <Dashboard /> : <Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to={user ? '/home' : '/login'} replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppShell />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
